module.exports = __webpack_public_path__ + "static/img/event-default-bg.4b5f97c4.png";